// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  border-radius: 4px;
  flex: 1;
`;

export const OverallStatusContainer = styled.div`
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const MotorStatusContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  height: 100%;
  border-radius: 4px;
  flex-direction: column;
  flex: 1;
  display: flex;
`;

export const ShaftRpmContainer = styled.div<{ isLastInRow?: boolean; isLastRow?: boolean }>`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  border-right: ${({ isLastInRow, theme }) => (
    isLastInRow
      ? 'none'
      : `1px solid ${theme.color.crusherDashboard.borderColor}`
  )};
  border-bottom: ${({ isLastRow, theme }) => (
    isLastRow
      ? 'none'
      : `1px solid ${theme.color.crusherDashboard.borderColor}`
  )};

  @media (min-width: ${BREAKPOINTS.md}px) {
    border-bottom: none;
    border-right: ${({ theme }) => `1px solid ${theme.color.crusherDashboard.borderColor}`};
  };
`;

export const Motor1AmpsContainer = styled.div<{ isLastInRow?: boolean; isLastRow?: boolean }>`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  border-right: ${({ isLastInRow, theme }) => (
    isLastInRow
      ? 'none'
      : `1px solid ${theme.color.crusherDashboard.borderColor}`
  )};
  border-bottom: ${({ isLastRow, theme }) => (
    isLastRow
      ? 'none'
      : `1px solid ${theme.color.crusherDashboard.borderColor}`
  )};

  @media (min-width: ${BREAKPOINTS.md}px) {
    border-bottom: none;
    border-right: ${({ theme }) => `1px solid ${theme.color.crusherDashboard.borderColor}`};
  };
`;

export const Motor2AmpsContainer = styled.div<{ isLastInRow?: boolean; isLastRow?: boolean }>`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  border-right: ${({ isLastInRow, theme }) => (
    isLastInRow
      ? 'none'
      : `1px solid ${theme.color.crusherDashboard.borderColor}`
  )};
  border-bottom: ${({ isLastRow, theme }) => (
    isLastRow
      ? 'none'
      : `1px solid ${theme.color.crusherDashboard.borderColor}`
  )};

  @media (min-width: ${BREAKPOINTS.md}px) {
    border-bottom: none;
    border-right: ${({ theme }) => `1px solid ${theme.color.crusherDashboard.borderColor}`};
  };
`;

export const DriveSpeedContainer = styled.div<{ isLastInRow?: boolean; isLastRow?: boolean }>`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  border-right: ${({ isLastInRow, theme }) => (
    isLastInRow
      ? 'none'
      : `1px solid ${theme.color.crusherDashboard.borderColor}`
  )};
  border-bottom: ${({ isLastRow, theme }) => (
    isLastRow
      ? 'none'
      : `1px solid ${theme.color.crusherDashboard.borderColor}`
  )};

  @media (min-width: ${BREAKPOINTS.md}px) {
    border-bottom: none;
    border-right: none;
  };
`;
